import React from 'react';
import styled from '@emotion/styled';
import ReactSelect from '../../../components/Dropdown/ReactSelect';
import { Filters } from '../../../components/Filters/Filters';
import { L } from '../../../lib/i18n';
import { SelectOption } from '../DataType';
import Cross from '../../../components/Icon/e-remove-outline-12.svg';
import { style } from '../../../components/Shared/Style';

const DropdownContainer = styled.div({
    display: 'flex',
    columnGap: '0.625rem',
});

const StyledCross = styled(Cross)({
    alignSelf: 'center',
    gridArea: 'icon',
    width: '16px',
    color: '#4B506D66',
    marginRight: '5px',
});

const Label = styled.div({
    fontSize: style.fontSize.milli,
    fontWeight: style.fontWeight.bold,
    paddingRight: style.margin.m,
    textTransform: 'uppercase',
});

type Props = {
    options: { name: string; value: string; newValue: string; id: number }[];
    filterOptions: Record<string, { value: string; label: string }[]>;
    selected: {
        [key: string]: SelectOption[];
    };
    setSelected: {
        [key: string]: (value: SelectOption[]) => void;
    };
    clearAll: () => void;
};

const FilterTableData = ({ options, filterOptions, selected, setSelected, clearAll }: Props) => {
    return (
        <Filters marginBottom={'0'} marginRight={'0'}>
            <DropdownContainer>
                {options.map((option) => (
                    <ReactSelect
                        key={option.id}
                        closeMenuOnSelect={false}
                        placeholder={L(option.name)}
                        controlShouldRenderValue={false}
                        isMulti
                        hideSelectedOptions={false}
                        options={filterOptions[option.name]}
                        value={selected[option.value]}
                        onChange={(multiValues) => setSelected[option.newValue]([...multiValues])}
                        isSearchable={true}
                    />
                ))}
            </DropdownContainer>
            <div style={{ display: 'flex', cursor: 'pointer', marginLeft: '0.5rem' }} onClick={() => clearAll()}>
                <StyledCross />
                <Label>{L('clear_filter')}</Label>
            </div>
        </Filters>
    );
};

export default FilterTableData;
